/* eslint-disable no-useless-escape */
export const ApiErrorMessage = "Something Went Wrong!";

export const FormItemRequiredRule = {
  required: true,
  message: "This is Required",
};

export const UserPasswordRequiredRule = {
  min: 8,
  message: "Password must be minimum 8 characters.",
};

export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const urlPattern =
  /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+.~#?&\/=]*)$/;

export const COMPANY_NAME = "inprofile.co";
